import { render, staticRenderFns } from "./FlatVoc.vue?vue&type=template&id=76f0a3c7&scoped=true&"
import script from "./FlatVoc.vue?vue&type=script&lang=js&"
export * from "./FlatVoc.vue?vue&type=script&lang=js&"
import style0 from "./FlatVoc.vue?vue&type=style&index=0&id=76f0a3c7&lang=css&scoped=true&"
import style1 from "./FlatVoc.vue?vue&type=style&index=1&id=76f0a3c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f0a3c7",
  null
  
)

export default component.exports